// 需要隐藏的area
export const hiddenAreas = ['CN'];


// WEBPACK FOOTER //
// ./src/config/index.js